import { LocalStorage } from "src/services/LocalStorage";

type DebugStorageKey = "debugProfilingEnabled";

class DebugServiceClass {
    isProfilingEnabled(): boolean {
        const stored = LocalStorage.getItem("debugProfilingEnabled" as DebugStorageKey);
        return stored === "true";
    }
}

export const DebugService = new DebugServiceClass();
